export default __webpack_public_path__ + "static/media/ecx_cat2_icon_Award_300_rgb.74c36478.png";